import axios from 'axios';

export const notificationService = {
  async notifications(page = 1) { return (await axios.get('/notifications', { params: { page } })).data; },
  async markNotificationRead(id) { return (await axios.post('/notifications/' + encodeURIComponent(id) + '/read')).data; },
  async markNotificationsRead() { return (await axios.post('/notifications/read')).data; },
};

export function updateNotificationBadge(count) {
  window.dispatchEvent(new CustomEvent('student-notifications-changed', { detail: count }));
}

// Accept only application-relative destinations supplied by the backend.
export function notificationDestination(data) {
  if (!data || data.unavailable) return null;
  const url = data.url || data.route;
  if (typeof url !== 'string' || !/^\/(?!\/)/.test(url) || /[\\\s]/.test(url)) return null;
  return url;
}
